/**
 * Die Hall of Shame — vier Ranglisten, keine Gnade.
 */
import { Link } from 'react-router-dom'
import { api } from '../api/client.js'
import { useLaden } from '../api/laden.js'
import type { Rangliste } from '../api/typen.js'
import { Abschnitt, Fehlermeldung, Laufvermerk, LeererZustand } from '../bausteine/Bausteine.js'

export function HallOfShame() {
  const listen = useLaden(() => api.get<Rangliste[]>('/api/hall-of-shame'))

  if (listen.laedt) return <Laufvermerk />
  if (listen.fehler) return <Fehlermeldung text={listen.fehler} />

  return (
    <>
      <section className="pt-8 text-center">
        <h1 className="urteil">Hall of Shame</h1>
        <p className="mt-3 text-sm text-akte/75">
          Die Kammer führt Buch. Diese Listen führen es öffentlich.
        </p>
      </section>

      {(listen.daten ?? []).map((liste) => (
        <Abschnitt key={liste.key} titel={liste.titel}>
          <p className="mb-2 text-xs text-akte/60">{liste.erlaeuterung}</p>
          {liste.plaetze.length === 0 ? (
            <LeererZustand text="Noch niemand aktenkundig. Das ändert sich." />
          ) : (
            <ol className="flex flex-col gap-1.5">
              {liste.plaetze.map((platz, i) => (
                <li key={platz.memberId}>
                  <Link
                    to={`/konto/${platz.memberId}`}
                    className="flex items-center gap-3 border border-eiche bg-bank px-3.5 py-2.5 transition-colors hover:border-messing"
                  >
                    <span className="randnummer w-6 shrink-0 pt-0 text-center">{i + 1}</span>
                    <span aria-hidden="true">{platz.avatarEmoji}</span>
                    <span className="min-w-0 flex-1 truncate text-lampe">{platz.name}</span>
                    <span className="protokoll shrink-0 normal-case">{platz.anzeige}</span>
                  </Link>
                </li>
              ))}
            </ol>
          )}
        </Abschnitt>
      ))}
    </>
  )
}
